import React, {useEffect} from 'react';
import Router from './Router';
import {Provider} from 'react-redux';
import {
    ComposedModal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    TextInput,
    Select,
    SelectItem
} from "carbon-components-react";

import {ThemeProvider} from 'styled-components';
import {themeSwitcher} from 'theme';
import configureStore from './store';

import moment from 'moment';
import {getAccessJwtToken, validToken} from "./services";
//import 'moment/locale/pt-br';


moment.locale('en-us');
const store = configureStore();

//const themeName = process.env.REAC_APP_SYSTEM || 'nxtdemand';
//window.LOG_LEVEL='DEBUG'

function App() {
    validToken();
    return (
        <div>
            {(!(localStorage.getItem("token")) && (window.location.pathname != "/" && window.location.href.indexOf("/recovery/") == -1)) ? (
                <ComposedModal size="xs" open preventCloseOnClickOutside>
                    <ModalHeader label="Aviso" title={""} onClick={e => (window.location.assign("/"))}/>
                    <ModalBody>
                        <p> Ops. essa sessão expirou!<br/>
                            Faça login novamente.
                        </p>
                    </ModalBody>
                    <ModalFooter primaryButtonText="Login" onClick={e => (window.location.assign("/"))}/>
                </ComposedModal>) : ("")}
            <Provider store={store}>
                <Router/>
            </Provider>
        </div>
    );
}

export default App;
